// Reusable password input with an eye toggle to show/hide the value.
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordField({ testId, value, onChange, minLength, required = true, className = "" }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        required={required}
        type={visible ? "text" : "password"}
        minLength={minLength}
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-3 pe-12 rounded-2xl neu-inset focus:outline-none focus:ring-2 focus:ring-[#1e3a8a55] ${className}`}
      />
      <button
        data-testid={`${testId}-toggle`}
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "hide password" : "show password"}
        className="absolute inset-y-0 end-3 flex items-center text-slate-500 hover:text-slate-700 active:scale-90 transition"
      >
        {visible ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
